import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

// Catches render-time errors in the routed content so a single bad run record
// (or any component bug) degrades to an inline message instead of unmounting the
// whole app to a blank white page. Callers key this by route so navigating away
// — including the browser Back button — clears the error and re-renders.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Dashboard render error:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <section>
          <h2>Something went wrong</h2>
          <p className="error">This view failed to render.</p>
          <p className="muted">{this.state.error.message}</p>
          <button className="btn-secondary" onClick={() => window.location.reload()}>
            Reload
          </button>
        </section>
      );
    }
    return this.props.children;
  }
}
